// @flow
import _ from 'lodash'
import type { Crop } from '../../../components/types'

type AdvertisementReplica = {|
  columnImageErrors: Array<string>,
  columnImageStoreId: ?string,
  multiImageStoreId: ?string,
  multiImageErrors: Array<string>,
  videoStoreId: ?string,
  videoErrors: Array<string>,
  snippetImageStoreId: ?string,
  snippetImageCrop: ?Crop,
  snippetImageErrors: Array<string>,
  fbImageCrop: ?Crop,
  fbInstagramImageStoreId: ?string,
  fbInstagramImageCrop: ?Crop,
  fbInstagramImageErrors: Array<string>,
  fbStoriesImageStoreId: ?string,
  fbStoriesImageCrop: ?Crop,
  fbStoriesImageErrors: Array<string>,
  fbThumbnailImageStoreId: ?string,
  fbThumbnailImageCrop: ?Crop,
  fbThumbnailImageErrors: Array<string>,
  vkColumnImageCrop: ?Crop,
  vkMultiImageCrop: ?Crop,
  vkArticleImageCrop: ?Crop,
  vkSiteImageCrop: ?Crop,
  vkBigImageStoreId: ?string,
  vkBigImageErrors: Array<string>,
  glImageCrop: ?Crop,
  tmColumnImageCrop: ?Crop,
  tmMultiImageCrop: ?Crop,
  tmSmallImageStoreId: ?string,
  tmSmallImageCrop: ?Crop,
  tmSmallImageErrors: Array<string>
|}

type AdvertisementReplicaPatch = $Shape<AdvertisementReplica>

type AddAction = {|
  +type: 'REPLICA.ADD',
  +state: AdvertisementReplica
|}

type RemoveAction = {|
  +type: 'REPLICA.REMOVE',
  +index: number
|}

type PatchAction = {|
  +type: 'REPLICA.PATCH',
  +index: number,
  +diff: AdvertisementReplicaPatch
|}

type Action = AddAction | RemoveAction | PatchAction

export type {
  Action,
  AddAction,
  RemoveAction,
  PatchAction,
  AdvertisementReplica,
  AdvertisementReplicaPatch
}

type State = Array<AdvertisementReplica>

export type { State }

export function add(state: AdvertisementReplica): AddAction {
  return {
    type: 'REPLICA.ADD',
    state
  }
}

export function remove(index: number): RemoveAction {
  return {
    type: 'REPLICA.REMOVE',
    index
  }
}

export function patch(index: number, diff: AdvertisementReplicaPatch): PatchAction {
  return {
    type: 'REPLICA.PATCH',
    index,
    diff
  }
}

const initialState: State = []

export const emptyReplica: AdvertisementReplica = {
  columnImageErrors: [],
  columnImageStoreId: null,
  fbImageCrop: null,
  fbInstagramImageCrop: null,
  fbInstagramImageErrors: [],
  fbInstagramImageStoreId: null,
  fbStoriesImageCrop: null,
  fbStoriesImageErrors: [],
  fbStoriesImageStoreId: null,
  fbThumbnailImageCrop: null,
  fbThumbnailImageErrors: [],
  fbThumbnailImageStoreId: null,
  glImageCrop: null,
  multiImageErrors: [],
  multiImageStoreId: null,
  snippetImageCrop: null,
  snippetImageErrors: [],
  snippetImageStoreId: null,
  tmColumnImageCrop: null,
  tmMultiImageCrop: null,
  tmSmallImageCrop: null,
  tmSmallImageErrors: [],
  tmSmallImageStoreId: null,
  videoErrors: [],
  videoStoreId: null,
  vkArticleImageCrop: null,
  vkBigImageErrors: [],
  vkBigImageStoreId: null,
  vkColumnImageCrop: null,
  vkMultiImageCrop: null,
  vkSiteImageCrop: null
}

function patchItem(state: State, index: number, transformItem: Function) {
  const item = state[index]
  const result = _.cloneDeep(state)

  result[index] = transformItem(item)

  return result
}

export default function(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'REPLICA.ADD':
      return [...state, action.state]
    case 'REPLICA.REMOVE': {
      let replicas = _.cloneDeep(state)
      replicas.splice(action.index, 1)
      return replicas
    }
    case 'REPLICA.PATCH': {
      const typedAction: PatchAction = action
      return patchItem(state, typedAction.index, (item) => ({ ...item, ...typedAction.diff }))
    }
    default:
      return state
  }
}
